import { TTranslator } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import { EDuration } from 'types';

export const formatDuration = (
  duration: EDuration,
  t: TTranslator<TLocalesKeys>
): string => {
  if (duration === EDuration.weeks) {
    return t('time.contracted.weeks');
  }

  if (duration === EDuration.days) {
    return t('time.contracted.days');
  }

  if (duration === EDuration.hours) {
    return t('time.contracted.hours');
  }

  return t('time.contracted.minutes');
};
